import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockShield = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "lock-shield" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 6.75,
			y: 9.75,
			width: 10.5,
			height: 7.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,13.125a.375.375,0,1,0,.375.375A.374.374,0,0,0,12,13.125h0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,9.75V7.5a3.75,3.75,0,0,1,7.5,0V9.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,23.25C5.324,21.469.75,17.51.75,10.5V.75h22.5V10.5C23.25,17.505,18.683,21.467,12,23.25Z"
		})
	]
});
export default SvgLockShield;
